<template>
  <div>
    <!-- 上下侧边 -->
    <!-- 上 -->
    <!-- <div
      v-show="istop"
      class="fixed max-w-[1400px] w-full tar top-0 left-0 flex items-center justify-center mx-auto z-99"
    >
      <img class="w-full" src="@/assets/images/hf.png" alt="" />
    </div> -->
    <!-- <div
      v-show="istop"
      class="fixed max-w-[1400px] w-full sh tar top-0 left-0 flex items-center justify-center flex-col mx-auto bg-[#fff] z-99"
    >
      <div class="flex items-center justify-between w-full box-border p-[10px]">
        <div class="flex items-center gap-[10px]">
          <img class="w-40px h-40px" src="@/assets/images/logo.png" alt="" />
          <div class="text-[#db2639] text-[13px]">
            <div>
              <b> 红桃视频-下载不迷路,无处不在 </b>
            </div>
            <div>海量高清无码，国产吃瓜抢先看</div>
          </div>
        </div>
        <div class="flex items-center gap-[10px] text-[12px]">
          <div
            class="flex items-center justify-center w-[67px] h-[28px] rounded-[28px] bg-[#ff4d03] text-[#fff] cursor-pointer"
          >
            下载APP
          </div>
          <van-icon size="20" name="cross" />
        </div>
      </div>
      <div class="grid grid-cols-5 gap-1 box-border px-[10px] pb-[10px] text-[12px] w-full">
        <div
          v-for="(item, index) in 5"
          :key="index"
          class="h-[25px] w-full text-[#fff] rounded-[3px] flex items-center justify-center"
          :class="[index % 2 == 0 ? 'bg-[#f00]' : 'bg-[#ffae00]']"
        >
          良家上门
        </div>
      </div>
    </div> -->
    <!-- 下 -->
    <div
      v-if="xlist && xlist.length > 0"
      class="fixed max-w-[1400px] w-full tar bottom-0 left-0 flex items-center justify-center mx-auto z-99"
    >
      <van-swipe
        :show-indicators="false"
        :loop="true"
        :autoplay="3000"
        class="h-[20vw] w-full md:h-[150px]"
        vertical
      >
        <van-swipe-item
          class="h-[20vw] w-full md:h-[150px]"
          v-for="(item, index) in xlist"
          :key="index"
          @click="handelUrl(item)"
        >
          <img class="w-full h-full" v-lazy="item.logo" alt="" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- 侧边 -->
    <div
      v-show="istop && isCbGb && clist && clist.length > 0"
      class="fixed bottom-[11%] right-0 flex items-center justify-center flex-col mx-auto z-98"
    >
      <van-icon
        size="20px"
        name="clear"
        class="posa top-[-8px] right-0 bg-[#fff] rounded-[50%]"
        @click="handelCbGb"
      />

      <img
        v-for="(item, index) in clist"
        :key="index"
        class="max-w-[60px] max-h-[60px] rounded-[10px] m-[2px] w-[18vw] h-[18vw]"
        v-lazy="item.logo"
        alt=""
        @click="handelUrl(item)"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeMount } from 'vue'
// const { ref, onMounted, onBeforeMount } = window.Vue
const props = defineProps({
  clist: {
    type: Array,
    default: () => []
  },
  xlist: {
    type: Array,
    default: () => []
  }
})

const istop = ref(false)
// 获取元素距离视口顶部的距离
function updateDistance() {
  const rect = distanceDisplay.value.getBoundingClientRect() // 获取元素的位置信息
  const distanceFromTop = rect.top

  if (distanceFromTop <= 15) {
    istop.value = true
    // console.log(istop.value)
  } else {
    istop.value = false
    // console.log(istop.value)
  }
}

const distanceDisplay = ref(null)
onMounted(() => {})

const scroll = () => {
  distanceDisplay.value = document.getElementById('distance')
  // console.log(distanceDisplay.value, 'distanceDisplay.value ')

  window.addEventListener('scroll', updateDistance)
  // 初始化显示距离
  updateDistance()
}
onBeforeMount(() => {
  window.removeEventListener('scroll', updateDistance)
})

const isCbGb = ref(true)
const handelCbGb = () => {
  isCbGb.value = !isCbGb.value
}
const handelUrl = (item) => {
  window.open(item.href, '_blank')
}
defineExpose({ scroll })
</script>

<style scoped>
.tar {
  left: 50%;
  transform: translateX(-50%);
}
.sh {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}
</style>
